import { render } from "./Journal_Details.vue?vue&type=template&id=c2a1d96e"
import script from "./Journal_Details.vue?vue&type=script&lang=js"
export * from "./Journal_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__